exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-table-head.end[data-v-6b597410] {\n  text-align: right;\n}\n[data-v-6b597410] .md-table-cell.action-buttons {\n  padding-right: 30px;\n  text-align: right;\n}\n.details > div[data-v-6b597410] {\n  display: inline-block;\n}\n.details a[data-v-6b597410] {\n  cursor: pointer;\n}\n.details-box[data-v-6b597410] {\n  width: 33%;\n}\n.header-button[data-v-6b597410] {\n  margin-right: 10px;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 12px;\n}\n", ""]);

// exports
